export default __webpack_public_path__ + "img/screenshot_5.61ae3ad9.png";